export const GET_LIST_MEDIA_ASYNC = 'GET_LIST_MEDIA_ASYNC';
export const GET_LIST_MEDIA_SUCCESS = 'GET_LIST_MEDIA_SUCCESS';

export const DELETE_MEDIA_ASYNC = 'DELETE_MEDIA_ASYNC';
export const DELETE_MEDIA_SUCCESS = 'DELETE_MEDIA_SUCCESS';

export const ADD_MEDIA_ASYNC = 'ADD_MEDIA_ASYNC';
export const ADD_MEDIA_SUCCESS = 'ADD_MEDIA_SUCCESS';

export const GET_MEDIA_BY_ID_ASYNC = 'GET_MEDIA_BY_ID_ASYNC';
export const GET_MEDIA_BY_ID_SUCCESS = 'GET_MEDIA_BY_ID_SUCCESS';

export const UPDATE_MEDIA_BY_ID_ASYNC = 'UPDATE_MEDIA_BY_ID_ASYNC';
export const UPDATE_MEDIA_BY_ID_SUCCESS = 'UPDATE_MEDIA_BY_ID_SUCCESS';

export const GET_MEDIA_BY_CATEGORIES_ASYNC = 'GET_MEDIA_BY_CATEGORIES_ASYNC';
export const GET_MEDIA_BY_CATEGORIES_SUCCESS = 'GET_MEDIA_BY_CATEGORIES_SUCCESS';

export const CHECK_COPY_MEDIA_ASYNC = 'CHECK_COPY_MEDIA_ASYNC';
export const CHECK_COPY_MEDIA_SUCCESS = 'CHECK_COPY_MEDIA_SUCCESS';

export const CHECK_COPY_MEDIA_BY_REGION_ASYNC = 'CHECK_COPY_MEDIA_BY_REGION_ASYNC';
export const CHECK_COPY_MEDIA_BY_REGION_SUCCESS = 'CHECK_COPY_MEDIA_BY_REGION_SUCCESS';

export const SET_COPY_MEDIA_TO_PROJECT_ASYNC = 'SET_COPY_MEDIA_TO_PROJECT_ASYNC';
export const SET_COPY_MEDIA_TO_PROJECT_SUCCESS = 'SET_COPY_MEDIA_TO_PROJECT_SUCCESS';

export const GET_PROJECT_LIST_ASYNC = 'GET_PROJECT_LIST_ASYNC';
export const GET_PROJECT_LIST_SUCCESS = 'GET_PROJECT_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/MediaLibrary/constants.js